<template>
  <div class="page_header">
    <span class="back text_size_14 text_color_regular" @click="back">
      {{$t('topedit.layout.header.back')}}
    </span>
    <span class="line"></span>
    <span class="title text_size_18 text_weight_bold">{{ title }}</span>
  </div>
</template>

<script>
export default {
  props: {
    title: String
  },
  methods: {
    // 返回
    back () {
      this.$emit('back')
    }
  }
}
</script>

<style lang="scss" scoped>
  .page_header {
    display: flex;
    align-items: center;
    min-height: 60px;
    .back {
      cursor: pointer;
    }
    .line {
      width:1px;
      height:23px;
      border:1px solid rgba(96,98,102,1);
      margin: 0 11px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/page-header/index.vue